import type { DrawingAOIMode } from "../types";

export function createLeafletDrawingAOI(map: any, mode: DrawingAOIMode) {
  return {
    activate() {
      console.log("Activating Leaflet drawing mode:", map, mode);
    },

    deactivate() {},
  };
}
